import React, { useState } from "react";

import { Table } from "lib/core_components/Table";
import { SpendFilters } from "lib/hooks/api/spend/spendFilters";
import { DEFAULT_TRANSACTION_SORT, useTransactionsTable } from "./hooks/useTransactionsTable";
import { TRANSACTION_COLUMN_FIELDS } from "./columns";
import { TransactionTableRow } from "./config";

type Props = {
  filters: SpendFilters;
  className?: string;
};

function TransactionsTable({ filters, className }: Props) {
  // Local rather than in the URL: the modal is opened over another page and closed again.
  const [sort, setSort] = useState(DEFAULT_TRANSACTION_SORT);
  const { data, isLoading, columns, pagination, isError, onSortChange } = useTransactionsTable(
    filters,
    TRANSACTION_COLUMN_FIELDS,
    { tableKey: "transactions-table", sort, onSortChange: setSort },
  );

  return (
    <Table
      columns={columns}
      dataSource={data}
      isError={isError}
      pagination={{
        ...pagination,
        onChange: (page, pageSize) => {
          pagination.onChange(page || 1, pageSize);
        },
        showSizeChanger: true,
      }}
      onChange={(_pagination, _filters, sorter) => onSortChange(sorter)}
      rowKey={(r) => (r as TransactionTableRow).id}
      loading={isLoading}
      className={className}
      scroll={{ x: "max-content" }}
    />
  );
}

export default TransactionsTable;
